"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./FileViewer.css");
var FileViewer = (function (_super) {
    __extends(FileViewer, _super);
    function FileViewer(props) {
        var _this = _super.call(this, props) || this;
        _this._onHandleDeleteButtonClick = _this._onHandleDeleteButtonClick.bind(_this);
        _this._onHandleFileNameClick = _this._onHandleFileNameClick.bind(_this);
        return _this;
    }
    FileViewer.prototype._onHandleDeleteButtonClick = function (event) {
        var handleDeleteButtonClick = this.props.handleDeleteButtonClick;
        handleDeleteButtonClick && handleDeleteButtonClick(event);
    };
    FileViewer.prototype._onHandleFileNameClick = function (event) {
        var handleFileNameClick = this.props.handleFileNameClick;
        handleFileNameClick && handleFileNameClick(event);
        event.preventDefault();
    };
    FileViewer.prototype._getFileNameProps = function () {
        var _a = this.props, fileName = _a.fileName, fileUrl = _a.fileUrl, fileUrlTarget = _a.fileUrlTarget, handleFileNameClick = _a.handleFileNameClick;
        var props = {
            title: fileName
        };
        if (fileUrl) {
            props['href'] = fileUrl;
            props['target'] = fileUrlTarget ? "_" + fileUrlTarget.toLowerCase() : '_blank';
        }
        if (handleFileNameClick) {
            props['href'] = '#';
            props['onClick'] = this._onHandleFileNameClick;
        }
        return props;
    };
    FileViewer.prototype._getIconProps = function () {
        var _a = this.props, fileIconName = _a.fileIconName, brandIconName = _a.brandIconName, fileIconBackgroundColor = _a.fileIconBackgroundColor;
        var brandIcon = brandIconName || 'None';
        var iconClass = (brandIcon === 'None') ?
            "p-file-icon p-file-icon-" + fileIconName.toLowerCase() :
            "p-brand-icon p-brand-icon-" + brandIcon.toLowerCase();
        var props = {
            className: iconClass,
            'aria-hidden': true
        };
        if (fileIconBackgroundColor) {
            props['style'] = {
                backgroundColor: fileIconBackgroundColor
            };
        }
        return props;
    };
    FileViewer.prototype.render = function () {
        var _a = this.props, tag = _a.tag, deleteIconLabel = _a.deleteIconLabel, fileName = _a.fileName, fileSize = _a.fileSize, fileUrl = _a.fileUrl, fileDetailsSection = _a.fileDetailsSection, handleDeleteButtonClick = _a.handleDeleteButtonClick, handleFileNameClick = _a.handleFileNameClick;
        var fileWrapperClassNames = [
            'p-file-viewer',
            'p-p-md',
            'p-bc-grey60',
            'p-bw-xs',
            'rounded-all',
            'p-bs-solid',
        ].join(' ');
        var isLink = (fileUrl != null || handleFileNameClick != null);
        var FileName = isLink ? 'a' : 'div';
        var fileNameClassNames = isLink ? "p-text p-f-sz-md p-t-primary50 p-t-full-hv-primary50 p-f-w-6 p-t-wr-el" : "p-text p-f-sz-md p-t-grey30 p-f-w-6 p-t-wr-el";
        return (React.createElement("div", { className: fileWrapperClassNames, "data-tag": tag },
            React.createElement("div", { className: "p-p-r-md p-file-viewer-file-icon" },
                React.createElement("div", __assign({}, this._getIconProps()))),
            React.createElement("div", { className: "file-details-wrapper" },
                React.createElement(FileName, __assign({ className: fileNameClassNames }, this._getFileNameProps()), fileName),
                !fileDetailsSection
                    && fileSize
                    && React.createElement("div", { className: "p-text p-f-sz-md p-t-meta p-f-w-6 p-t-wr-el", title: fileSize }, fileSize),
                fileDetailsSection),
            handleDeleteButtonClick && (React.createElement("div", { className: "button-wrapper" },
                React.createElement("button", { className: "close", onClick: this._onHandleDeleteButtonClick, title: deleteIconLabel, type: "button", "aria-label": fileName },
                    React.createElement("i", { className: "p-icon-cross p-t-muted" }))))));
    };
    return FileViewer;
}(React.Component));
exports.default = FileViewer;
//# sourceMappingURL=FileViewer.js.map


//////////////////
// WEBPACK FOOTER
// ../player-file-viewer/build/control/FileViewer.js
// module id = 310
// module chunks = 0 2